// Hero/index.tsx
import { useTranslation } from "react-i18next"
import { Layout, HeroContainer, BackgroundImage, Content, Title, Subtitle, Description } from "./Style"

const Hero: React.FC = () => {
  const { t } = useTranslation("home/hero")

  const isMobile = window.innerWidth <= 768

  return (
    <Layout>
      <HeroContainer>
        <BackgroundImage />
        <Content>
          <Title>{t("title")}</Title>
          <Subtitle>{t("subtitle")}</Subtitle>
          {!isMobile && <Description>{t("description")}</Description>}
        </Content>
      </HeroContainer>
    </Layout>
  )
}

export default Hero
